"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePdfClient = usePdfClient;
const PdfClient_1 = require("@juvare/platform-sdk-js/PdfClient");
const react_1 = __importDefault(require("react"));
function usePdfClient(baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new PdfClient_1.PdfClient(baseUrl, tokenProvider), [baseUrl, tokenProvider]);
}
